import * as React from 'react';
import { Navigate, useLocation } from 'react-router';
import { parse } from 'query-string';
import { sessionKeys } from '../../../core/session';
import { customerContext } from '../../../contexts/customer/CustomerContext';

const Integration = () => {
	const location = useLocation();
	const context = React.useContext(customerContext);
	const queryParams = parse(location.search);
	const accessToken = queryParams.accessToken as string;
	const pageName = queryParams.pageName as string;
	const candidateId = queryParams.candidateId as string;
	const workflowId = queryParams.workflowId as string;
	React.useEffect(() => {
		if (accessToken) {
			localStorage.setItem(sessionKeys.accessToken, accessToken);
			context.resetContext();
		}
	}, []);

	return <Navigate to={getLoggedRedirectPath(pageName, candidateId, workflowId)} replace />;
};

const getLoggedRedirectPath = (pageName: string, candidateId: string, workflowId: string) => {
	switch (pageName) {
		case 'profile':
			return `/candidates/${candidateId}/details`;
		case 'request':
			return candidateId ? `/candidates/${candidateId}/checks/add` : `/candidates/create`;
		case 'report': {
			if (candidateId && workflowId) return `/candidates/${candidateId}/report/${workflowId}`;
			return `/candidates/${candidateId}/report`;
		}
		default:
			return '/candidates';
	}
};

export default Integration;
